import * as React from 'react'

export default () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="13.9788" cy="13.9798" r="7.68" stroke="#8FB4FF" strokeWidth="1.5" />
    <circle cx="13.9797" cy="13.9797" r="4.8" stroke="#8FB4FF" strokeWidth="1.5" />
    <circle cx="13.9805" cy="13.9796" r="1.92" fill="#8FB4FF" />
    <path d="M13.9785 21.6598V6.2998" stroke="#8FB4FF" strokeWidth="1.5" />
    <path d="M6.30016 13.9795H21.6602" stroke="#8FB4FF" strokeWidth="1.5" />
  </svg>
)
